import { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import { useFormikContext } from 'formik';
import Typography from '@material-ui/core/Typography';
import MLink from '@material-ui/core/Link';
import RadioGroupField from '../forms/radio-group-field';
import TextAreaField from '../forms/text-area-field';
import { eventRegistrationTypes } from '../../utils/events';

const EventFormRegistration = ({ disabled, forceTouched }) => {
  const {
    values: { registrationType },
  } = useFormikContext();

  const options = useMemo(() => {
    return _map(eventRegistrationTypes, ({ name, description }, value) => ({
      label: `${name}${description ? ` (${description})` : ''}`,
      value,
    }));
  }, []);

  return (
    <Fragment>
      <Typography variant="h2">Registration</Typography>
      <RadioGroupField
        name="registrationType"
        label="Registration"
        disabled={disabled}
        touched={forceTouched}
        options={options}
      />
      {registrationType === 'APPROVAL_REQUIRED' && (
        <Fragment>
          <TextAreaField
            name="approvalPrompt"
            label="Pre-RSVP Request Prompt"
            helperText="Shown when someone clicks to request to RSVP"
            disabled={disabled}
            touched={forceTouched}
          />
          <TextAreaField
            name="approvalDescription"
            label="Post-RSVP Event Description"
            disabled={disabled}
            touched={forceTouched}
            helperText={(
              <span>
                <MLink href="https://www.markdownguide.org/basic-syntax/" target="_blank">
                  Markdown
                </MLink>
                {' '}is supported. The main event description is always shown, but this info is only shown once RSVP is approved.
              </span>
            )}
          />
        </Fragment>
      )}
    </Fragment>
  );
};

EventFormRegistration.propTypes = {
  disabled: PropTypes.bool.isRequired,
  forceTouched: PropTypes.bool.isRequired,
};

export default EventFormRegistration;
